import { useEffect, useRef } from 'react';

import type { HotelPanelState } from '@voll-intelligence/genui-contract';

export type PanelReport = { panel?: HotelPanelState; total?: number };

/** Chama `onChange` com `value` quando o CONTEÚDO dele (não a identidade) ou o
 *  próprio `onChange` mudam: quem produz `value` entrega um objeto novo a cada
 *  render, e quem escuta só quer saber da troca. Compara depois de cada commit
 *  com o último aviso dado. */
export function useNotifyOnContentChange<T>(
  value: T,
  onChange: ((value: T) => void) | undefined,
): void {
  const sent = useRef<{ key: string; to: typeof onChange } | null>(null);
  useEffect(() => {
    const key = JSON.stringify(value);
    if (sent.current?.key === key && sent.current.to === onChange) return;
    sent.current = { key, to: onChange };
    onChange?.(value);
  });
}

/** Avisa o card quando o estado reportável do painel MUDA (por conteúdo, não
 *  por identidade). Fora do organismo pelo teto de linhas dele. */
export function usePanelReport(
  report: PanelReport,
  onPanelReport: ((report: PanelReport) => void) | undefined,
): void {
  useNotifyOnContentChange(report, onPanelReport);
}
